export const SET_PAGE_TITLE = 'NAVIGATION_SET_PAGE_TITLE';
export const TOGGLE_NAV = 'NAVIGATION_TOGGLE_NAV';
export const OPEN_MAP_PAGE = 'UI_OPEN_MAP_PAGE';
